
<template>
  <div class="lang-switcher" v-on-clickaway="close">
    <button class="lang-trigger" @click="isOpen = !isOpen">
      <img :src="`https://flagcdn.com/w20/${getLocalFlagString()}.png`" alt="flag" class="lang-flag">
      <span>{{ $i18n.locale.toUpperCase() }}</span>
      <span class="lang-arrow" :class="{ 'is-open': isOpen }">&#9662;</span>
    </button>
    <div v-if="isOpen" class="lang-dropdown">
      <button class="lang-option" @click="select('en')">
        <img src="https://flagcdn.com/w20/us.png" alt=""> English
      </button>
      <button class="lang-option" @click="select('fr')">
        <img src="https://flagcdn.com/w20/fr.png" alt=""> Français
      </button>
      <button class="lang-option" @click="select('ru')">
        <img src="https://flagcdn.com/w20/ru.png" alt=""> Pусский
      </button>
      <button class="lang-option" @click="select('zh')">
        <img src="https://flagcdn.com/w20/cn.png" alt=""> 普通话
      </button>
      <button class="lang-option" @click="select('kr')">
        <img src="https://flagcdn.com/w20/kr.png" alt=""> 한국어
      </button>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import mixinMethods from '@/mixins/misc'

export default {
  mixins: [clickaway, mixinMethods],
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    select (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('lang', locale)
      this.isOpen = false
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.lang-switcher {
  position: relative;
  display: inline-block;
}

.lang-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  color: #363636;
  transition: border-color 0.15s, box-shadow 0.15s;
  white-space: nowrap;
}

.lang-trigger:hover {
  border-color: #b5b5b5;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}

.lang-flag {
  width: 20px;
  height: auto;
  display: block;
}

.lang-arrow {
  font-size: 0.75rem;
  transition: transform 0.2s;
  line-height: 1;
}

.lang-arrow.is-open {
  transform: rotate(180deg);
}

.lang-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  background: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  z-index: 100;
  min-width: 150px;
  overflow: hidden;
}

.lang-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
  color: #363636;
  text-align: left;
  transition: background 0.12s;
}

.lang-option:hover {
  background: #f5f5f5;
}

.lang-option img {
  width: 20px;
  height: auto;
  flex-shrink: 0;
}
</style>
